import { AxiosError } from 'axios';
import { GET_RESIT_EXAM_LEVELS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_RESIT_EXAM_LEVELS_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import { KeyValueResponse } from '../../api';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  token?: string;
  onSuccess?: (data: KeyValueResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetResitExamLevels = ({ token, onSuccess, onError }: Input = {}) => {
  const getResitExamLevels = async () => {
    const res = await axiosClient.get<KeyValueResponse[]>(GET_RESIT_EXAM_LEVELS(token));
    return res.data;
  };

  return useCustomQuery(GET_RESIT_EXAM_LEVELS_KEY, getResitExamLevels, {
    onSuccess,
    onError,
  });
};
